import { combine } from "effector";
import { $jsScriptsMap } from "../jsScripts";
import { $scriptsMap } from "../scripts";

export const $allScriptsMap = combine($scriptsMap, $jsScriptsMap, (scriptsMap, jsScriptsMap) => ({
  ...scriptsMap,
  ...jsScriptsMap,
}));
